<template>
  <div class="iqos-toast">
      <div :class="toastHeaderClass">
          <BaseIcon :icon="toastIcon"/>
          <span class="qrw-label-sm w-100">
              {{ toastTitle }}
          </span>
          <span class="v1-grey-6-color" @click="$emit('close')">
              <BaseIcon icon="x"/>
          </span>
      </div>
      <BaseDivider color="v1-grey-4" class="mt-8" v-if="content && variant != 'confirm'"/>
      <div class="mt-8 qrw-label-sm v1-grey-10-color" v-if="content && variant != 'confirm'">
          {{ toastContent }}
      </div>
      <BaseButton size="md" color="v1-grey-10" variant="secondary" icon="lifebuoy" v-if="variant == 'error'" class="mt-24 w-100" @click="openSupport">
        {{ $t('notification_toast.support') }}
      </BaseButton>
  </div>
</template>

<script>
export default {
    props: {
        variant: {
            type: String,
            default: 'info'
        },
        content: String
    },
    computed: {
        toastHeaderClass() {
            return {
                'toast-header': true,
                'green-6-color': this.variant == 'confirm',
                'red-3-color': this.variant == 'error',
                'v1-grey-10-color': this.variant == 'info'
            }
        },
        toastIcon() {
            return {
                info: 'alert-circle',
                error: 'allert',
                confirm: 'check'
            }[this.variant];
        },
        toastTitle() {
            return {
                error: this.$t('notification_toast.error'),
                confirm: this.content,
                info: this.$t('notification_toast.info')
            }[this.variant];
        },
        toastContent() {
            return {
                error: this.$t('error_codes.'+this.content),
                info: this.content,
                confirm: ''
            }[this.variant];
        }
    },
    mounted() {
        setTimeout(() => {
            this.$emit('close');
        }, 10 * 1000);
    },
    methods: {
        openSupport() {
            window.Intercom('show');
        }
    }
}
</script>

<style scoped>
.toast-header {
    display: flex;
    column-gap: 8px;

    align-content: center;
    align-items: center;
}

.iqos-toast {
    padding: 16px;
    border-radius: 4px;

    background: var(--v1-grey-1-color);
    box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
    width: 320px;
    min-width: 320px;
    max-width: 320px;

    cursor: pointer;

    animation: toast-slidein 0.2s;

    position: relative;
}

@keyframes toast-slidein {
  from {
    right: -400px;
  }

  to {
    right: 0;
  }
}

</style>
